const header = document.querySelector(".header");
const anchorList = document.querySelector(".js-anchor-list");

if (anchorList) {
  const headerHeight = header ? header.offsetHeight : 0;
  const anchorListHeight = anchorList ? anchorList.offsetHeight : 0;
  const OFFSET = 45;

  const links = document.querySelectorAll(".js-anchor-list li a");

  function getTargetTop(target) {
    const isSticky =
      anchorList &&
      ["sticky", "fixed"].includes(getComputedStyle(anchorList).position);

    const extraOffset = isSticky ? anchorListHeight + 30 : 0;

    return (
      window.pageYOffset +
      target.getBoundingClientRect().top -
      headerHeight -
      extraOffset -
      OFFSET
    );
  }

  links.forEach((link) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      const targetId = this.getAttribute("href");
      const target = document.querySelector(targetId);
      if (!target) return;

      window.scrollTo({
        top: getTargetTop(target),
        behavior: "smooth",
      });

      links.forEach((l) => l.classList.remove("is-active"));
      this.classList.add("is-active");

      scrollAnchorIntoView(this);
    });
  });

  const sections = Array.from(links)
    .map((link) => document.querySelector(link.getAttribute("href")))
    .filter(Boolean);

  let currentId = null;

  window.addEventListener("scroll", () => {
    const scrollPosition = window.scrollY + window.innerHeight / 2;

    let newId = null;
    for (let section of sections) {
      if (scrollPosition >= section.offsetTop) {
        newId = section.id;
      }
    }

    if (newId && newId !== currentId) {
      currentId = newId;
      links.forEach((link) => {
        const isActive = link.getAttribute("href") === `#${currentId}`;
        link.classList.toggle("is-active", isActive);

        if (isActive) {
          scrollAnchorIntoView(link);
        }
      });
    }
  });

  function scrollAnchorIntoView(link) {
    const container = anchorList;
    const containerRect = container.getBoundingClientRect();
    const linkRect = link.getBoundingClientRect();

    if (linkRect.left < containerRect.left) {
      container.scrollBy({
        left: linkRect.left - containerRect.left - 8,
        behavior: "smooth",
      });
    } else if (linkRect.right > containerRect.right) {
      container.scrollBy({
        left: linkRect.right - containerRect.right + 8,
        behavior: "smooth",
      });
    }
  }
}
